export default "__VITE_ASSET__nmDEM_jV__"